module.exports = __webpack_public_path__ + "img/world.cfb90444.png";